import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Badge } from '../Badge';

const Callout = props => {
	const { className, label, children, variant, wrap } = props;
	const calloutClass = classNames(
    {
       'py-2 flex-middle bg-neutral-0': variant === 'badge',
       'flex-wrap ':  wrap,
       'py-3 px-2': variant === 'default'
    
    },
    'flex flex-start bg-grey-05 br-4',
    className
  );
  const childrenClass = classNames(
    {
      "fs-3 c-neutral-700" : variant === "default",
			"fs-2 c-neutral-700 fw-500 " : variant === "badge",
			"px-2": wrap
    }
  )
	return (
		<div className={calloutClass}>
			{variant === 'badge' ? (
				<div className='mx-2 flex'>
					<Badge type='error' size='sm' className="fw-700 h-4 flex-middle flex px-2">
						{label}
					</Badge>
				</div>
			) : (
				<div className='fs-3 tt-uppercase fw-600 mx-2'>{label}</div>
			)}
			<div className={childrenClass}>{children}</div>
		</div>
	);
};

Callout.propTypes = {
	/**
	 * Classes to be added appended to the wrapping element
	 */
	className: PropTypes.string,
	/**
	 * Optional label to prepend to children
	 */
  label: PropTypes.string,
  	/**
	 * Determines type of Callout.
	 */
	variant: PropTypes.string,
	/**
	 * Next to be rendered in the callout
	 */
  children: PropTypes.node.isRequired,
  /**
	 * Wrap text to next line
	 */
  wrap: PropTypes.bool,
};

Callout.defaultProps = {
	className: '',
  label: 'Note',
  variant: 'default',
  wrap: false
};

Callout.displayName = 'Callout';

export { Callout };
